import React from 'react';
import { Link } from 'react-router-dom';

export const LEGAL_PAGES = [
  { to: '/legal/aviso-legal', label: 'Aviso legal' },
  { to: '/legal/privacidad', label: 'Privacidad' },
  { to: '/legal/condiciones', label: 'Condiciones de venta' }
];

// Links to the legal pages, for every footer.
const LegalLinks = ({ className = '' }) => (
  <nav aria-label="Información legal" className={`flex flex-wrap gap-x-6 gap-y-2 ${className}`}>
    {LEGAL_PAGES.map((page) => (
      <Link key={page.to} to={page.to} className="transition-colors hover:text-[var(--lp-text)]">
        {page.label}
      </Link>
    ))}
  </nav>
);

export default LegalLinks;
